import React from "react";
import { Text } from "@showitinc/showit-wc";
import { FORMS_FLAG } from "@/constants/FeatureFlags.mjs";
import useV2Feature from "@/hooks/useV2Feature";

import Input from "../../../base/Input";
import { initFormatter } from "../../../../utils/PropertyFormatters";
import { INPUT_TYPE_TEXT } from "../../../../constants/ElementConstants";
import { SWITCH } from "../../../../constants/InputConstants.mjs";
import { prepareInputUtils } from "../../../../utils/InputUtils";
import {
  IN_SUBJECT,
  IS_FIELD,
  LABEL,
  REPLY_TO,
  REQUIRED,
  WP_FIELD,
  WP_PROPS,
} from "../../../../constants/PropNames.js";

const TextFormProperties = ({ onPropUpdate, isLocked, preparedElement }) => {
  const isFormsEnabled = useV2Feature(FORMS_FLAG);
  const _onCheckChange = (propInfo) => {
    propInfo.value = propInfo.value === true ? 1 : null;
    onPropUpdate(propInfo);
  };

  const { onChange: onCheck } = initFormatter(_onCheckChange);
  const { onChange } = initFormatter(onPropUpdate);

  const { isMixed, prepareValue } = prepareInputUtils(undefined, preparedElement);

  const formProps = prepareValue("form");
  const isField = prepareValue(IS_FIELD) && !isMixed(IS_FIELD);
  const isWPElement = prepareValue(WP_FIELD);

  const disabled = isMixed(WP_FIELD) || isMixed(WP_PROPS) || isWPElement;
  // With native forms on, only an existing legacy field keeps the section.
  const hasAnyField = isField || isMixed(IS_FIELD);

  if (disabled || (isFormsEnabled && !hasAnyField)) {
    return null;
  }

  const prepareCheckValue = (propName) =>
    !isMixed(propName) ? prepareValue(propName, false) : false;

  return (
    <>
      <Text className="panel-subheading">Contact Form</Text>
      <Input
        checked={isField}
        disabled={isLocked}
        inputType={SWITCH}
        label="Enable Input"
        onSIChange={onCheck(IS_FIELD, isField)}
      />
      {formProps && isField && (
        <>
          <Input
            checked={prepareCheckValue(REQUIRED)}
            disabled={isLocked}
            inputType={SWITCH}
            label="Required"
            onSIChange={onCheck(REQUIRED, prepareCheckValue(REQUIRED))}
          />
          <Input
            checked={prepareCheckValue(IN_SUBJECT)}
            disabled={isLocked}
            inputType={SWITCH}
            label="In Subject"
            onSIChange={onCheck(IN_SUBJECT, prepareCheckValue(IN_SUBJECT))}
          />
          <Input
            checked={prepareCheckValue(REPLY_TO)}
            disabled={isLocked}
            inputType={SWITCH}
            label="Reply To"
            onSIChange={onCheck(REPLY_TO, prepareCheckValue(REPLY_TO))}
          />
          <Input
            disabled={isLocked}
            label="Label"
            onSIBeforeChange={onChange(LABEL, prepareValue(LABEL))}
            onSIInput={onChange(LABEL, prepareValue(LABEL), false)}
            placeholder="Input Label"
            reserveContext
            value={prepareValue(LABEL, "")}
            type={INPUT_TYPE_TEXT}
          />
        </>
      )}
    </>
  );
};

export default TextFormProperties;
